import { useTranslation } from 'react-i18next';

import FilterLine from '@/assets/icons/filter_line.svg?component';
import { Button } from '@/components/atoms/Buttons';

import CellIcon from '../cells/CellIcon';

import styles from './DetailsFilterButton.module.scss';

interface DetailsFilterButtonProps {
    /** Which value it filters by, such as "Filter by IP address: 198.51.100.23". */
    name: string;
    onFilter: () => void;
}

/**
 * The keyboard path to every filter the table offers by mouse. The tooltip says what the
 * button does; its name says which value, since a screen reader lists many of them.
 */
export default function DetailsFilterButton({ name, onFilter }: DetailsFilterButtonProps) {
    const { t } = useTranslation();
    return (
        <Button
            variant="tertiary"
            size="small"
            tooltip={t('auditLog.details.filter')}
            className={styles.filterButton}
            onClick={onFilter}
            iconOnly
            aria-label={name}
            icon={<CellIcon icon={FilterLine} className={styles.icon} />}
            tooltipPlacement="left"
        />
    );
}
